import { render, staticRenderFns } from "./yw.vue?vue&type=template&id=4896eef8&scoped=true&"
import script from "./yw.vue?vue&type=script&lang=js&"
export * from "./yw.vue?vue&type=script&lang=js&"
import style0 from "./yw.vue?vue&type=style&index=0&id=4896eef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896eef8",
  null
  
)

export default component.exports